"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { style: { "max-height": "40vh", "overflow": "scroll" } };
const _hoisted_2 = { class: "the-note" };
const _hoisted_3 = { class: "the-top-right-buttons the-navigation-buttons" };
const _hoisted_4 = { style: { "position": "absolute", "right": "0.5rem", "top": "0.5rem", "display": "flex", "gap": "0.5rem", "z-index": "1" } };
const _hoisted_5 = {
    key: 0,
    class: "the-speed-scale-overlay"
};
const _hoisted_6 = { class: "the-speed-scale-label" };
const vue_3 = require("vue");
const map_config_1 = __importDefault(require("~/config/map.config"));
const vue_map_sdk_1 = require("@xenodrive/vue-map-sdk");
const LoadPage_vue_1 = __importDefault(require("@/components/LoadPage.vue"));
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
const BssMovementToggleListButton_vue_1 = __importDefault(require("@/components/BssMovementToggleListButton.vue"));
const BssMovementNaviationIcons_vue_1 = __importDefault(require("@/components/BssMovementNaviationIcons.vue"));
const BssMovementConfig_vue_1 = __importDefault(require("@/components/BssMovementConfig.vue"));
const BssMapEventInfobox_vue_1 = __importDefault(require("../components/BssMapEventInfobox.vue"));
const vue_timeline_1 = require("@xenodrive/vue-timeline");
const moment_1 = __importDefault(require("moment"));
const SPEED_SCALE_DEFAULT_MIN = 0;
const SPEED_SCALE_DEFAULT_MAX = 80;
const SPEED_SCALE_STEP = 20;
const SPEED_SCALE_BOTTOM_OFFSET_PX = 19;
const SPEED_SCALE_CENTER_OFFSET = 50;
const SPEED_SCALE_TOP_HEADROOM_PX = 6;
exports.default = (0, vue_1.defineComponent)({
    __name: 'MapLocus',
    props: {
        url: {}
    },
    setup(__props, { expose: __expose }) {
        const emptyMapData = {
            destinations: [],
            dropdown_events: [],
            events: [],
            loci: [],
            movement_settings: {},
        };
        const mapData = (0, vue_3.ref)(Object.assign({}, emptyMapData));
        const props = __props;
        function onload() {
            window.initialize();
            window.$('body').trigger('bss:onload');
        }
        const query = (0, vue_3.computed)(() => {
            const search = new URLSearchParams(location.search);
            return '?' + search.toString();
        });
        const messages = (0, vue_3.reactive)({
            event_id_messages: {},
            event_types: {},
        });
        const showMenu = (0, vue_3.ref)(true);
        const mapCenter = (0, vue_3.ref)([137.333872222, 38.0849725]);
        const mapZoom = (0, vue_3.ref)(0);
        const map = (0, vue_3.ref)();
        const vehicleTime = (0, vue_3.ref)(null);
        const timelineTime = (0, vue_3.ref)();
        const timelineZoom = (0, vue_3.ref)(3);
        const timeRange = (0, vue_3.computed)(() => {
            if (mapData.value.loci.length > 0) {
                const [min, max] = mapData.value.loci.reduce((acc, row) => [
                    Math.min(acc[0], new Date(row.time).getTime()),
                    Math.max(acc[1], new Date(row.time).getTime()),
                ], [Infinity, -Infinity]);
                return [min, max];
            }
            return [-Infinity, Infinity];
        });
        (0, vue_3.watch)(timeRange, () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            yield (0, vue_3.nextTick)();
            if (isFinite((_a = timeRange.value[0]) !== null && _a !== void 0 ? _a : 0) && isFinite((_b = timeRange.value[1]) !== null && _b !== void 0 ? _b : 0)) {
                timelineTime.value = (((_c = timeRange.value[0]) !== null && _c !== void 0 ? _c : 0) + ((_d = timeRange.value[1]) !== null && _d !== void 0 ? _d : 0)) / 2;
            }
        }));
        const popups = (0, vue_3.ref)({});
        const filterModeEvents = (0, vue_3.ref)();
        function calcDirection(prev, curr) {
            if (!prev)
                return null;
            // XXX: simple calc
            return ((Math.atan2(Number(curr.longitude_w) - Number(prev.longitude_w), Number(curr.latitude_w) - Number(prev.latitude_w)) *
                180) /
                Math.PI);
        }
        function bisectLeft(data, value, valueFn) {
            let l = 0, r = data.length;
            while (l < r) {
                const m = (l + r) >> 1;
                if (valueFn(data[m]) < value)
                    l = m + 1;
                else
                    r = m;
            }
            return l;
        }
        const pathValue = (x) => x.average_speed;
        const path = (0, vue_3.computed)(() => {
            return mapData.value.loci.map((l, idx) => [
                Number(l.longitude_w),
                Number(l.latitude_w),
                Object.assign(Object.assign({}, l), { time_value: new Date(l.time).getTime(), direction: calcDirection(mapData.value.loci[idx - 1], l) }),
            ]);
        });
        (0, vue_3.watch)(path, () => {
            var _a;
            const extent = path.value.reduce((acc, [x, y]) => [Math.min(acc[0], x), Math.min(acc[1], y), Math.max(acc[2], x), Math.max(acc[3], y)], [Infinity, Infinity, -Infinity, -Infinity]);
            if (isFinite(extent[0])) {
                (_a = map.value) === null || _a === void 0 ? void 0 : _a.api.fitToExtent(extent);
            }
        });
        const marker = (0, vue_3.computed)(() => {
            if (!path.value.length)
                return null;
            if (vehicleTime.value === null)
                return null;
            const idx = bisectLeft(path.value, vehicleTime.value, (v) => v[2].time_value);
            if (idx < 0 || idx >= path.value.length)
                return null;
            const l = path.value[idx][2];
            return {
                icon: 'arrow_blue',
                coordinate: [Number(l.longitude_w), Number(l.latitude_w)],
                direction: l.direction,
            };
        });
        const dirty = (0, vue_3.ref)(false);
        function jumpToVehicle() {
            if (dirty.value && marker.value) {
                mapCenter.value = (0, vue_map_sdk_1.parseLngLat)(marker.value.coordinate).toCoordinate();
            }
            else if (!dirty.value) {
                dirty.value = true;
            }
        }
        function onPathClick(e) {
            if (!e.hit)
                return;
            vehicleTime.value = timelineTime.value = path.value[e.hit.idx][2].time_value;
        }
        const events = (0, vue_3.computed)(() => Object.fromEntries(mapData.value.events.map((e) => [
            `${e.event_type}_${e.id}`,
            {
                id: `event:${e.event_type}_${e.id}`,
                coordinate: [Number(e.longitude_w), Number(e.latitude_w)],
                icon: [
                    'icon_event_work', // green
                    'icon_event_warning', // red
                    'icon_event_shoot', // blue
                    'icon_event_regular', // white
                    'icon_event_default', // black
                ][e.event_type - 1],
                data: e,
            },
        ])));
        const eventsFiltered = (0, vue_3.computed)(() => {
            return !filterModeEvents.value
                ? events.value
                : Object.fromEntries(filterModeEvents.value.map((type_id) => [type_id, events.value[type_id]]));
        });
        const checkIcons = ['fa-solid:square-check', 'fa-regular:square', 'fa-solid:square-minus'];
        const checkedList = (0, vue_3.ref)({
            speed: true,
            engine: true,
        });
        function checked(name) {
            return Boolean(checkedList.value[name]);
        }
        function toggle(name) {
            checkedList.value[name] = !Boolean(checkedList.value[name]);
        }
        const symmetric = (0, vue_3.computed)(() => {
            return checked('temperature1') || checked('temperature2') || checked('temperature3') || checked('temperature4');
        });
        const series = (0, vue_3.computed)(() => {
            var _a, _b;
            return [
                ...(checked('speed')
                    ? [
                        (0, vue_3.markRaw)(new vue_timeline_1.TimelineDataSeries({
                            dataRange: {
                                auto: true,
                                default: [0, 80],
                            },
                            chart: {
                                color: '#080',
                                minmaxFill: true,
                            },
                            title: '速度',
                            unit: 'km/h',
                            label: {
                                digits: 1,
                            },
                            source: (_a = mapData.value.loci) !== null && _a !== void 0 ? _a : [],
                            parser: (data) => {
                                var _a;
                                return (_a = data === null || data === void 0 ? void 0 : data.flatMap((row) => row.average_speed == null
                                    ? []
                                    : [
                                        {
                                            time: new Date(row.time).getTime(),
                                            value: [row.min_speed, row.max_speed, row.average_speed],
                                        },
                                    ])) !== null && _a !== void 0 ? _a : [];
                            },
                        })),
                    ]
                    : []),
                ...(checked('engine')
                    ? [
                        (0, vue_3.markRaw)(new vue_timeline_1.TimelineDataSeries({
                            dataRange: {
                                auto: true,
                                default: [-80, 80],
                            },
                            chart: {
                                color: '#800',
                                minmaxFill: true,
                            },
                            source: (_b = mapData.value.loci) !== null && _b !== void 0 ? _b : [],
                            title: 'エンジン回転数',
                            unit: 'rpm',
                            label: {
                                prefix: '回転数',
                                digits: 0,
                            },
                            parser: (data) => {
                                var _a;
                                return (_a = data === null || data === void 0 ? void 0 : data.flatMap((row) => row.average_engine_rpm == null
                                    ? []
                                    : [
                                        {
                                            time: new Date(row.time).getTime(),
                                            value: [row.min_engine_rpm, row.max_engine_rpm, row.average_engine_rpm],
                                        },
                                    ])) !== null && _a !== void 0 ? _a : [];
                            },
                        })),
                    ]
                    : []),
                ...['temperature1', 'temperature2', 'temperature3', 'temperature4'].flatMap((id, idx) => {
                    var _a;
                    return !checked(id)
                        ? []
                        : [
                            (0, vue_3.markRaw)(new vue_timeline_1.TimelineDataSeries({
                                dataRange: {
                                    auto: true,
                                    default: [-40, 40],
                                },
                                chart: {
                                    color: ['#008', '#088', '#808', '#880'][idx],
                                },
                                source: (_a = mapData.value.loci) !== null && _a !== void 0 ? _a : [],
                                title: '温度 Ch.1',
                                unit: '℃',
                                label: {
                                    digits: 1,
                                },
                                parser: (data) => data === null || data === void 0 ? void 0 : data.flatMap((row) => [
                                    {
                                        time: new Date(row.time).getTime(),
                                        value: Number(row[id]) === 3276.7 ? NaN : Number(row[id]),
                                        //value: Number(row[id]),
                                    },
                                ]),
                            })),
                        ];
                }),
            ];
        });
        function format(d) {
            return (0, moment_1.default)(d).format('MM/DD HH:mm');
        }
        const SPEED_SCALE_DEFAULT_RANGE = [SPEED_SCALE_DEFAULT_MIN, SPEED_SCALE_DEFAULT_MAX];
        const speedDataRange = (0, vue_3.ref)([...SPEED_SCALE_DEFAULT_RANGE]);
        let offSpeedChange = null;
        (0, vue_3.watch)(series, (newSeries) => {
            // 前回のchangeハンドラを解除
            offSpeedChange === null || offSpeedChange === void 0 ? void 0 : offSpeedChange();
            offSpeedChange = null;
            // チャート内の速度の範囲を取得
            const speed = newSeries.find((s) => { var _a; return ((_a = s.options) === null || _a === void 0 ? void 0 : _a.title) === '速度'; });
            if (!speed) {
                speedDataRange.value = [...SPEED_SCALE_DEFAULT_RANGE];
                return;
            }
            // 速度メモリの範囲に設定
            speedDataRange.value = [...speed.options.dataRange];
            offSpeedChange = speed.on('change', () => {
                speedDataRange.value = [...speed.options.dataRange];
            });
        }, { immediate: true });
        (0, vue_3.onUnmounted)(() => {
            offSpeedChange === null || offSpeedChange === void 0 ? void 0 : offSpeedChange();
        });
        const speedScaleMarks = (0, vue_3.computed)(() => {
            const [rangeMin, rangeMax] = speedDataRange.value;
            const span = rangeMax - rangeMin;
            if (!(span > 0))
                return [];
            const start = Math.ceil(rangeMin / SPEED_SCALE_STEP) * SPEED_SCALE_STEP;
            const marks = [];
            for (let value = start; value <= rangeMax; value += SPEED_SCALE_STEP) {
                const ratio = (value - rangeMin) / span;
                const bottom = symmetric.value
                    ? `calc(${SPEED_SCALE_CENTER_OFFSET}% + ${ratio} * (100% - ${SPEED_SCALE_CENTER_OFFSET}% - ${SPEED_SCALE_TOP_HEADROOM_PX}px))`
                    : `calc(${SPEED_SCALE_BOTTOM_OFFSET_PX}px + ${ratio} * (100% - ${SPEED_SCALE_BOTTOM_OFFSET_PX}px - ${SPEED_SCALE_TOP_HEADROOM_PX}px))`;
                marks.push({ value, bottom });
            }
            return marks;
        });
        const hasLocusData = (0, vue_3.computed)(() => { var _a, _b; return ((_b = (_a = mapData.value.loci) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0; });
        // --------------
        const mode = (0, vue_3.ref)('movement_locus');
        (0, vue_3.watch)(mode, () => {
            const url = new URL(location.href);
            url.searchParams.set('mode', mode.value);
            location.href = url.toString();
        });
        function closePopup(popup) {
            var _a, _b;
            if (!popup)
                return;
            const key = (_a = popup.id) !== null && _a !== void 0 ? _a : (_b = Object.entries(popups.value).find(([_k, v]) => v === popup)) === null || _b === void 0 ? void 0 : _b[0];
            if (key) {
                delete popups.value[key];
            }
        }
        function openPopup(popup) {
            var _a;
            if (!popup)
                return;
            const key = (_a = popup === null || popup === void 0 ? void 0 : popup.id) !== null && _a !== void 0 ? _a : 'none';
            popups.value[key] = popup;
            mapCenter.value = (0, vue_map_sdk_1.parseLngLat)(popup.coordinate).toCoordinate();
        }
        function togglePopup(popup) {
            var _a;
            if (!popup)
                return;
            if (popups.value[(_a = popup === null || popup === void 0 ? void 0 : popup.id) !== null && _a !== void 0 ? _a : ''])
                closePopup(popup);
            else
                openPopup(popup);
        }
        const clusterMarkers = (0, vue_3.ref)([]);
        const clusterPopupAnchor = (0, vue_3.ref)(undefined);
        const clusterPopup = (0, vue_3.ref)(false);
        function onClusterClicked(e) {
            if (e.markers && e.markers.length > 0) {
                clusterMarkers.value = [...e.markers].sort((a, b) => new Date(a.data.time).getTime() - new Date(b.data.time).getTime());
                clusterPopupAnchor.value = [e.clientX, e.clientY];
                clusterPopup.value = true;
            }
        }
        function onEventClicked(e) {
            return __awaiter(this, void 0, void 0, function* () {
                if (e.markers && e.markers.length === 1) {
                    vehicleTime.value = timelineTime.value = new Date(e.markers[0].data.time).getTime();
                    togglePopup(e.markers[0]);
                    return;
                }
                onClusterClicked(e);
            });
        }
        (0, vue_3.provide)('messages', messages);
        __expose({
            init(options) {
                Object.assign(messages, options.messages);
            },
            resizeMap() {
                const parentArea = this.parent().first();
                this.height(parentArea.height());
                this.width(parentArea.width());
            },
            setMapData(data) {
                dirty.value = false;
                mapData.value = data;
            },
            resetMap(_isResetHome) {
                dirty.value = false;
                mapData.value = Object.assign({}, emptyMapData);
            },
            // ポップアップ(イベント)
            openInfoboxEvent(_type, rowId) {
                var _a;
                const e = (_a = events.value) === null || _a === void 0 ? void 0 : _a[rowId];
                if (e) {
                    vehicleTime.value = timelineTime.value = new Date(e.data.time).getTime();
                    openPopup(e);
                }
            },
            closeInfoboxEvent(_type, rowId) {
                var _a;
                closePopup((_a = events.value) === null || _a === void 0 ? void 0 : _a[rowId]);
            },
            closeInfoboxEventAll() {
                popups.value = {};
            },
            // 未使用
            openInfoboxDestination(_marker_type, _marker_id) { },
            closeInfoboxDestination(_marker_type, _marker_id) { },
            closeInfoboxDestinationAll() { },
            // フィルタ(イベント)
            isFilterModeEvents() { },
            setFilterModeEvents(target_marker_ids) {
                filterModeEvents.value = target_marker_ids;
            },
            resetFilterModeEvents() { },
            // 未使用
            isFilterModeDestinations() { },
            setFilterModeDestinations(_target_marker_ids) { },
            resetFilterModeDestinations() { },
            showRightareaButton(_mode) { },
            hideRightareaButton() { },
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.SidePanelContainer), null, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).Map, {
                        ref_key: "map",
                        ref: map,
                        center: mapCenter.value,
                        "onUpdate:center": _cache[14] || (_cache[14] = ($event) => ((mapCenter).value = $event)),
                        zoom: mapZoom.value,
                        "onUpdate:zoom": _cache[15] || (_cache[15] = ($event) => ((mapZoom).value = $event)),
                        "zoom-control": "left-top:1rem,5rem",
                        "scale-line": "",
                        onClick: _cache[16] || (_cache[16] = ($event) => (popups.value = {}))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).Path, {
                                coordinates: path.value,
                                value: pathValue,
                                flux: "",
                                onClick: onPathClick
                            }, null, 8, ["coordinates"]),
                            (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).Markers, {
                                markers: eventsFiltered.value,
                                onClick: (0, vue_2.withModifiers)(onEventClicked, ["stop"])
                            }, null, 8, ["markers"]),
                            (marker.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Markers, {
                                    key: 0,
                                    markers: [marker.value]
                                }, null, 8, ["markers"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Dropdown), {
                                active: clusterPopup.value,
                                "onUpdate:active": _cache[0] || (_cache[0] = ($event) => ((clusterPopup).value = $event)),
                                "popup-anchor": clusterPopupAnchor.value,
                                "no-trigger": ""
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownLabel), null, {
                                        default: (0, vue_2.withCtx)(() => _cache[17] || (_cache[17] = [
                                            (0, vue_2.createTextVNode)("候補選択", -1)
                                        ])),
                                        _: 1,
                                        __: [17]
                                    }),
                                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(clusterMarkers.value, (v) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                                key: v.id,
                                                onClick: ($event) => {
                                                    clusterPopup.value = false;
                                                    vehicleTime.value = timelineTime.value = new Date(v.data.time).getTime();
                                                    openPopup(v);
                                                }
                                            }, {
                                                default: (0, vue_2.withCtx)(() => {
                                                    var _a, _b, _c;
                                                    return [
                                                        (0, vue_2.createElementVNode)("div", null, [
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(format(v.data.time)) + " ", 1),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_2, " [" + (0, vue_2.toDisplayString)((_a = messages.event_types) === null || _a === void 0 ? void 0 : _a[v.data.event_type]) + "] " + (0, vue_2.toDisplayString)((_c = (_b = messages.event_id_messages) === null || _b === void 0 ? void 0 : _b[v.data.event_id]) !== null && _c !== void 0 ? _c : v.data.event_id), 1)
                                                        ])
                                                    ];
                                                }),
                                                _: 2
                                            }, 1032, ["onClick"]));
                                        }), 128))
                                    ])
                                ]),
                                _: 1
                            }, 8, ["active", "popup-anchor"]),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(popups.value, (popup, idx) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Popup, {
                                    key: idx,
                                    center: popup === null || popup === void 0 ? void 0 : popup.coordinate,
                                    onClose: ($event) => (closePopup(popup)),
                                    style: { "width": "max-content", "max-height": "30vh" }
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(BssMapEventInfobox_vue_1.default, {
                                            data: popup.data,
                                            "movement-settings": mapData.value.movement_settings
                                        }, null, 8, ["data", "movement-settings"])
                                    ]),
                                    _: 2
                                }, 1032, ["center", "onClose"]));
                            }), 128)),
                            (0, vue_2.createVNode)(BssMovementNaviationIcons_vue_1.default, {
                                modelValue: mode.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((mode).value = $event))
                            }, null, 8, ["modelValue"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createVNode)(BssMovementConfig_vue_1.default),
                                (0, vue_2.createVNode)(BssMovementToggleListButton_vue_1.default, {
                                    modelValue: showMenu.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showMenu).value = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).SidePanel, {
                                show: "",
                                side: "bottom",
                                style: { "height": "128px", "background": "white", "overflow": "auto" }
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_timeline_1.Timeline), {
                                        height: "100%",
                                        time: timelineTime.value,
                                        "onUpdate:time": _cache[11] || (_cache[11] = ($event) => ((timelineTime).value = $event)),
                                        zoom: timelineZoom.value,
                                        "onUpdate:zoom": _cache[12] || (_cache[12] = ($event) => ((timelineZoom).value = $event)),
                                        "time-range": timeRange.value,
                                        onTimechanged: jumpToVehicle,
                                        onTimechanging: _cache[13] || (_cache[13] = ($event) => (vehicleTime.value = $event))
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                                                    icon: "fa:search-minus",
                                                    color: "#4c87c7",
                                                    onClick: _cache[3] || (_cache[3] = ($event) => (timelineZoom.value--))
                                                }),
                                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                                                    icon: "fa:search-plus",
                                                    color: "#4c87c7",
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (timelineZoom.value++))
                                                }),
                                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Dropdown), null, {
                                                    trigger: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                                                            icon: "fa:layer-group",
                                                            color: "#4c87c7"
                                                        })
                                                    ]),
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                                            "checkbox-icons": checkIcons,
                                                            checkbox: "",
                                                            checked: checked('speed'),
                                                            onClick: _cache[5] || (_cache[5] = ($event) => (toggle('speed')))
                                                        }, {
                                                            default: (0, vue_2.withCtx)(() => _cache[18] || (_cache[18] = [
                                                                (0, vue_2.createTextVNode)(" 速度 ", -1)
                                                            ])),
                                                            _: 1,
                                                            __: [18]
                                                        }, 8, ["checked"]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                                            "checkbox-icons": checkIcons,
                                                            checkbox: "",
                                                            checked: checked('engine'),
                                                            onClick: _cache[6] || (_cache[6] = ($event) => (toggle('engine')))
                                                        }, {
                                                            default: (0, vue_2.withCtx)(() => _cache[19] || (_cache[19] = [
                                                                (0, vue_2.createTextVNode)(" 回転数 ", -1)
                                                            ])),
                                                            _: 1,
                                                            __: [19]
                                                        }, 8, ["checked"]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                                            "checkbox-icons": checkIcons,
                                                            checkbox: "",
                                                            checked: checked('temperature1'),
                                                            onClick: _cache[7] || (_cache[7] = ($event) => (toggle('temperature1')))
                                                        }, {
                                                            default: (0, vue_2.withCtx)(() => _cache[20] || (_cache[20] = [
                                                                (0, vue_2.createTextVNode)(" 温度 Ch.1 ", -1)
                                                            ])),
                                                            _: 1,
                                                            __: [20]
                                                        }, 8, ["checked"]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                                            "checkbox-icons": checkIcons,
                                                            checkbox: "",
                                                            checked: checked('temperature2'),
                                                            onClick: _cache[8] || (_cache[8] = ($event) => (toggle('temperature2')))
                                                        }, {
                                                            default: (0, vue_2.withCtx)(() => _cache[21] || (_cache[21] = [
                                                                (0, vue_2.createTextVNode)(" 温度 Ch.2 ", -1)
                                                            ])),
                                                            _: 1,
                                                            __: [21]
                                                        }, 8, ["checked"]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                                            "checkbox-icons": checkIcons,
                                                            checkbox: "",
                                                            checked: checked('temperature3'),
                                                            onClick: _cache[9] || (_cache[9] = ($event) => (toggle('temperature3')))
                                                        }, {
                                                            default: (0, vue_2.withCtx)(() => _cache[22] || (_cache[22] = [
                                                                (0, vue_2.createTextVNode)(" 温度 Ch.3 ", -1)
                                                            ])),
                                                            _: 1,
                                                            __: [22]
                                                        }, 8, ["checked"]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                                            "checkbox-icons": checkIcons,
                                                            checkbox: "",
                                                            checked: checked('temperature4'),
                                                            onClick: _cache[10] || (_cache[10] = ($event) => (toggle('temperature4')))
                                                        }, {
                                                            default: (0, vue_2.withCtx)(() => _cache[23] || (_cache[23] = [
                                                                (0, vue_2.createTextVNode)(" 温度 Ch.4 ", -1)
                                                            ])),
                                                            _: 1,
                                                            __: [23]
                                                        }, 8, ["checked"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_timeline_1.TimelineTrack), { symmetric: symmetric.value }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_timeline_1.TimelineChart), { series: series.value }, null, 8, ["series"])
                                                ]),
                                                _: 1
                                            }, 8, ["symmetric"]),
                                            (checked('speed') && hasLocusData.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(speedScaleMarks.value, (mark) => {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                            key: mark.value,
                                                            class: "the-speed-scale-line",
                                                            style: (0, vue_2.normalizeStyle)({ bottom: mark.bottom })
                                                        }, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(mark.value) + "km/h", 1)
                                                        ], 4));
                                                    }), 128))
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]),
                                        _: 1
                                    }, 8, ["time", "zoom", "time-range"])
                                ]),
                                _: 1
                            }),
                            _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("div", { style: { "position": "absolute", "left": "3rem", "top": "5rem" } }, null, -1))
                        ]),
                        _: 1,
                        __: [24]
                    }, 8, ["center", "zoom"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).SidePanel, {
                        show: showMenu.value,
                        side: "right",
                        style: { "width": "40vw", "background": "white", "overflow": "auto" }
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.ResizeHandle), { orientation: "vertical" }),
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.SidePanelContainer), null, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(LoadPage_vue_1.default, {
                                        url: props.url,
                                        query: query.value,
                                        onLoad: onload
                                    }, null, 8, ["url", "query"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["show"])
                ]),
                _: 1
            }));
        };
    }
});
